import * as formWizardConstants from './constants';

/**
 * Gets the FormWizard error tags associated with an element
 *
 * @param {Element} element
 */
export default function getErrorTags(element) {
  if (!element) return;
  return element.querySelectorAll(formWizardConstants.selectors.formFieldErrorTag);
}
